import React from 'react';
import TableStyles from './Table.module.css';

const Table = ({ title, tableHead, tableRow, containerStyle }) => {
	// Add a class to any table cell with the className "scrollable" to apply custom styling
	React.useEffect(() => {
		const scrollableCells = document.querySelectorAll('td.scrollable');
		scrollableCells.forEach(cell => {
			cell.classList.add(TableStyles.scrollable);
		});
	}, [tableRow]); // Re-apply when rows change

	return (
		<React.Fragment>
			{title && <p className={TableStyles.tableContent__header_heading}>{title}</p>}
			<div className={TableStyles.tableContent}>
				<div className={TableStyles.tableContainer} style={containerStyle}>
					<table className={TableStyles.table}>
						<thead>{tableHead}</thead>
						<tbody>{tableRow}</tbody>
					</table>
				</div>
			</div>
		</React.Fragment>
	);
};

export const TableButtons = ({ children }) => {
	return <div className={TableStyles.table__iconBox}>{children}</div>;
};

// A clickable <th> for client-side column sorting. Pair with the useSort hook:
//   const sort = useSort(filteredRows);
//   <SortableTh label="CVE" field="cve" sort={sort} />
// Shows an arrow for the active column; a third click clears the sort. `style`
// passes through so it matches a screen's existing header cells.
export const SortableTh = ({ label, field, sort, style, align }) => {
	const active = sort && sort.sortKey === field;
	const arrow = active ? (sort.sortDir === 'asc' ? ' ▲' : sort.sortDir === 'desc' ? ' ▼' : '') : '';
	return (
		<th
			onClick={() => sort && sort.requestSort(field)}
			style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap',
			         textAlign: align || 'left', ...(style || {}) }}
			title='Sort by this column'
		>
			{label}<span style={{ opacity: active ? 1 : 0.35 }}>{arrow || ' ⇅'}</span>
		</th>
	);
};

export const TableButton = ({ variant = 'primary', icon, label, onClick }) => {
	return (
		<button
			data-testid='table-btn-component'
			onClick={onClick}
			className={
				variant === 'primary' ? (
					TableStyles.table__button
				) : (
					[ TableStyles.table__button, TableStyles.table__button_delete ].join(' ')
				)
			}>
			<svg className={variant === 'primary' ? TableStyles.table__button_icon : TableStyles.table__button_icon_red}>
				<use xlinkHref={`/assets/sprite.svg#icon-${icon}`} />
			</svg>
			<span>{label}</span>
		</button>
	);
};

export default Table;
